function DevoteeQuotesSlider() {
  return (
    <div
      id="devoteeCarousel"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      <div className="carousel-inner text-center">

        {/* Slide 1 */}
        <div className="carousel-item active">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "Visiting this temple filled my heart with peace and devotion.
              The atmosphere is divine and calming.
              I felt spiritually connected and refreshed.
              Truly a place of blessings."
            </p>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "Darshanika helped me discover sacred places easily.
              Every temple visit brings new energy.
              My family felt blessed and joyful.
              A wonderful spiritual journey."
            </p>
          </div>
        </div>

        {/* Slide 3 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "This temple is not just a place, it is an experience.
              The silence speaks devotion.
              The prayers touch your soul.
              I will visit again for sure."
            </p>
          </div>
        </div>

        {/* Slide 4 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "The beauty of this holy place is beyond words.
              I found inner peace here.
              The environment is pure and positive.
              A must visit for every devotee."
            </p>
          </div>
        </div>

        {/* Slide 5 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "Every visit strengthens my faith.
              The temple radiates positive energy.
              It brings hope and happiness.
              I feel protected and blessed."
            </p>
          </div>
        </div>

        {/* Slide 6 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "The spiritual vibes here are unmatched.
              It gives mental peace.
              It removes stress and worries.
              A perfect place for meditation."
            </p>
          </div>
        </div>

        {/* Slide 7 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "Darshanika made my pilgrimage easy.
              I discovered new temples.
              My devotion increased.
              My journey became meaningful."
            </p>
          </div>
        </div>

        {/* Slide 8 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "This holy place connects people with God.
              The beauty of rituals is inspiring.
              Faith grows stronger here.
              Truly divine experience."
            </p>
          </div>
        </div>

        {/* Slide 9 */}
        <div className="carousel-item">
          <div className="card shadow p-4 mx-auto" style={{ maxWidth: "800px" }}>
            <h5 className="text-danger mb-3">❤️ Loved by Devotees</h5>
            <p className="fst-italic">
              "A temple is where the soul finds rest.
              Where prayers meet peace.
              Where hope is renewed.
              And devotion becomes life."
            </p>
          </div>
        </div>

      </div>

      {/* Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#devoteeCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon"></span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#devoteeCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon"></span>
      </button>
    </div>
  );
}

export default DevoteeQuotesSlider;